import { App } from "../features/home"
import { PageNotFound } from "../features/common"
import homeRoute from "../features/home/route"
import commonRoute from "../features/common/route"
import authRoute from "../features/auth/route"
import lhoExplorerRoute from "../features/lho-explorer/route"
import damageCaseRoute from "../features/damage-case/route"

// NOTE: DO NOT CHANGE the 'childRoutes' name and the declaration pattern.
// This is used for Rekit cmds to register routes config for new features, and remove config when remove features, etc.
const childRoutes = [homeRoute, commonRoute, authRoute, lhoExplorerRoute, damageCaseRoute]

const fallbackRoute = { path: "*", name: "Page not found", component: PageNotFound }

const routes = [
  {
    path: "/",
    component: App,
    childRoutes: [...childRoutes, fallbackRoute].filter(
      r => r.component || (r.childRoutes && r.childRoutes.length > 0),
    ),
  },
]

// Handle isIndex property of route config:
//  Dupicate it and put it as the first route rule.
function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return
  }

  const indexRoute = route.childRoutes.find(child => child.isIndex)
  if (indexRoute) {
    const first = { ...indexRoute }
    first.path = ""
    first.exact = true
    first.autoIndexRoute = true // mark it so that the simple nav won't show it.
    route.childRoutes.unshift(first)
  }
  route.childRoutes.forEach(handleIndexRoute)
}

routes.forEach(handleIndexRoute)
export default routes



// WEBPACK FOOTER //
// ./src/common/routeConfig.js